const isOnBoardTemplate = function () {
  return this.model.isOnBoardTemplate();
};
export { isOnBoardTemplate };
